module.exports = __webpack_public_path__ + "assets/projects/droplet/login.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/droplet/login.mp4
// module id = 44
// module chunks = 0